import { useRouter as useNextRouter } from 'next/navigation';
import { useCallback } from 'react';

import { fullNavigationPush, fullNavigationReplace } from './fullNavigation';

const shouldNavigateViaWindow = (href: unknown): href is string =>
  typeof href === 'string' && (href.startsWith('/forms/') || href.startsWith('/-/') || href.startsWith('http'));

export const useRouter = () => {
  const nextRouter = useNextRouter();

  const push = useCallback<typeof nextRouter.push>(
    (href, options) => {
      if (shouldNavigateViaWindow(href)) {
        fullNavigationPush(href);
        return;
      }
      return nextRouter.push(href, options);
    },
    [nextRouter],
  );

  const replace = useCallback<typeof nextRouter.replace>(
    (href, options) => {
      if (shouldNavigateViaWindow(href)) {
        fullNavigationReplace(href);
        return;
      }
      return nextRouter.replace(href, options);
    },
    [nextRouter],
  );

  return {
    push,
    replace,
    prefetch: nextRouter.prefetch,
    back: nextRouter.back,
    refresh: nextRouter.refresh,
  };
};
